const companyKey = 'company';

export function getCurrentCompanyId(): string | null {
  return localStorage.getItem(companyKey);
}

export function storeCurrentCompanyId(id: string) {
  return localStorage.setItem(companyKey, id);
}

export function removeCurrentCompanyId() {
  return localStorage.removeItem(companyKey);
}

export function getCookie(name: string): string | undefined {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

export function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value};`;
}
